import React from 'react'


class Footer extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }

    render() {
        const currentYear = new Date().getFullYear();
        return (
            <div id="mainFooterContainer" className="modern-footer">
                <div className="footer-content">
                    <div className="footer-text">
                        © {currentYear} Way Cup Coffee Shop. All rights reserved.
                    </div>
                    <div className="footer-links">
                        <a href="tel:+96170415225" className="footer-link">📞 +961 70 415 225</a>
                        <a href="mailto:info@waycup-lb.com" className="footer-link">✉️ info@waycup-lb.com</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;